<div class="form-modal">
	<mat-dialog-content>
		<a tabindex="0" (click)="onClose()" (keypress)="onClose()" class="close-modal"
			aria-label="Close organization edit form">
			<img src="./assets/img/icons-svg/close-icon.svg" />
		</a>
		<div class="img-wrapper">
			<div class="clearfix"></div>
			<div class="title-wrapper">
				<h1>{{ title }}</h1>
			</div>
		</div>

		<popup-loader *ngIf="!isLoaded"></popup-loader>
		<form
			novalidate
			[formGroup]="courseEditForm"
		>
			<div id="resource-section" class="form-wrapper-80" *ngIf="isLoaded">

				<mat-form-field class="wt-mat-form-field">
					<input matInput formControlName="titleen" required class="wt-mat-input" placeholder="Question (English)" type="text" />
					<mat-error *ngIf="f.titleen.touched && f.titleen.errors?.required">
						The Question (English) is required
					</mat-error>
				</mat-form-field>
                <div class="lang-Btn">
                    <a mat-button (click)="toggleField('French', 'Question')">
						{{ showQuestionFrench ? 'French Question' : 'French Question' }}
					</a>
                    <a mat-button (click)="toggleField('Spanish', 'Question')">
						{{ showQuestionSpanish ? 'Spanish Question' : 'Spanish Question' }}
					</a>
                </div>
                
                <mat-form-field class="wt-mat-form-field" *ngIf="showQuestionFrench">
					<input matInput formControlName="titlefr" class="wt-mat-input" placeholder="Question (French)" type="text" />
				</mat-form-field>

                <mat-form-field class="wt-mat-form-field" *ngIf="showQuestionSpanish">
					<input matInput formControlName="titlees" class="wt-mat-input" placeholder="Question (Spanish)" type="text" />
				</mat-form-field>

				<!-- <p class="red" *ngIf="showError">{{errors}}</p> -->

				<mat-form-field class="wt-mat-form-field">
					<input matInput class="wt-mat-input" required placeholder="Counselor Name (English)" type="text" formControlName="authoren" />
					<mat-error *ngIf="f.authoren.touched && f.authoren.errors?.required">
						The Counselor Name (English) is required
					</mat-error>
				</mat-form-field>
                <!-- <div class="lang-Btn">
                    <a mat-button (click)="toggleField('French', 'Counselor Name')">
						{{ showCounselorNameFrench ? 'French Counselor Name' : 'French Counselor Name' }}
					</a>
					<a mat-button (click)="toggleField('Spanish', 'Counselor Name')">
						{{ showCounselorNameSpanish ? 'Spanish Counselor Name' : 'Spanish Counselor Name' }}
					</a>
                </div>


                <mat-form-field class="wt-mat-form-field" *ngIf="showCounselorNameFrench">
					<input matInput class="wt-mat-input" placeholder="Counselor Name (French)" type="text" formControlName="authorfr" />
				</mat-form-field>

                <mat-form-field class="wt-mat-form-field" *ngIf="showCounselorNameSpanish">
					<input matInput class="wt-mat-input" placeholder="Counselor Name (Spanish)" type="text" formControlName="authores" />
				</mat-form-field> -->
				<!-- <p class="red" *ngIf="showError">{{errors}}</p> -->

				<mat-form-field class="wt-mat-form-field desctext-box">
					<mat-label for="category" translate 
						>Category</mat-label
					>
					<mat-select formControlName="category" required>
						<mat-option
							*ngFor="let category of categoryList"
							[value]="category.ID">
							{{ category.Title }}
						</mat-option>
					</mat-select>
					<mat-error
						*ngIf="f.category.touched && f.category.errors?.required"
					>
						The Category is required
					</mat-error>
				</mat-form-field>

                <div class="icon-input image-box">
					<label for="image">Background Image <span class="info-title">(Max: 2MB | Format: JPG/JPEG)</span></label>
					<input type="file" (change)="courseImageUpload($event)" #input>
				</div>
				<div class="preview image-preview" *ngIf="courseEditForm.value.imageUrl">
					<p>Image preview</p>
					<img [src]="courseEditForm.value.imageUrl" />
				</div>

                <div class="image-box">
                    <div class="attachments">
                        <div class="attachment">
                            <div class="icon-input">
                                <label for="audioFileUpload">Audio File <span class="info-title">(Max: 25MB | Format: MP3)</span></label>
                                <input placeholder="File Attachment" type="file"
                                       (change)="changeAudioUploadListener($event)">
                            </div>
							<p class="red" *ngIf="audioerror">{{errors}}</p>
                            <div class="preview audio-preview" *ngIf="courseEditForm.value.audioUrl">
								<label for="logo">Audio preview</label>
								<wt-audio [mediaUrl]="courseEditForm.value.audioUrl">
								</wt-audio>
							</div>
                        </div>
                    </div>
                </div>

				<div class="icon-input">
					<label for="logo">Transcript (English)<span>*</span></label>
					<ckeditor formControlName="transcripten" [config]="config" id="courseDescription" (change)="validateEditor()">
					</ckeditor>
					<mat-error *ngIf="f.transcripten.touched && f.transcripten.errors?.required">
						The Transcript (English) is required
					</mat-error>
				</div>
                <div class="lang-Btn">
                    <a mat-button (click)="toggleField('French', 'Description')">
						{{ showDescFrench ? 'French Transcript' : 'French Transcript' }}
					</a>
                    <a mat-button (click)="toggleField('Spanish', 'Description')">
						{{ showDescSpanish ? 'Spanish Transcript' : 'Spanish Transcript' }}
					</a>
                </div>
                <div class="icon-input desctext-box" *ngIf="showDescFrench">
					<label for="logo">Transcript (French)</label>
					<ckeditor formControlName="transcriptfr" [config]="config" id="courseDescription">
					</ckeditor>
				</div>
                <div class="icon-input desctext-box" *ngIf="showDescSpanish">
					<label for="logo">Transcript (Spanish)</label>
					<ckeditor formControlName="transcriptes" [config]="config" id="courseDescription">
					</ckeditor>
				</div>
			
				<!-- <div class="icon-input desclang-box">
					<mat-checkbox matInput formControlName="default">
						Default?
					</mat-checkbox>
				</div> -->

				<div class="icon-input  desclang-box">
					<mat-checkbox matInput formControlName="active">
						Active?
					</mat-checkbox>
				</div>
                <div class="fixed-footer">
                    <p class="red" *ngIf="submitButtonPressed && !courseEditForm.valid && errors === ''">Please check the errors</p>
                    <p class="red">{{errors}}</p>
                    <a tabindex="0" class="btn-primary btn-bold btn" (click)="doSave()" (keypress)="doSave()">Save</a>
                </div>
			</div>
		</form>
	</mat-dialog-content>
</div>
